import * as api from './api';
import * as types from './mutations';

const state = {
    isProcessing: false,
    collections: {}
};

const getters = {};

const actions = {
    getCollection({commit, state}, {collectionSlug}) {
        return new Promise((resolve, reject) => {
            if (state.collections[collectionSlug]) {
                return resolve(state.collections[collectionSlug]);
            }

            commit(types.SET_PROCESSING_STATE, true);

            axios.get(api.getCollection(collectionSlug))
                .then(({data}) => {
                    commit(types.UPDATE_FETCHED_COLLECTIONS, data.collection.data);
                    resolve(data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },
    
    enrol({commit}, {hashedId}) {
        commit(types.SET_PROCESSING_STATE, true);
        return new Promise((resolve, reject) => {
            axios.post(api.enrolCollection(hashedId))
                .then(_ => resolve())
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    }
};

const mutations = {
    [types.UPDATE_FETCHED_COLLECTIONS](state, data) {
        state.collections = _.assign({}, state.collections, {[data.slug]: data});
    },

    [types.SET_PROCESSING_STATE](state, isProcessing) {
        state.isProcessing = isProcessing;
    }
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
};